<section class="hashtags-overview">
    <h3>
        <span>Check hashtags</span>
        <span style="float:right; padding-right: 15px;">Page</span>
    </h3>
    <p class="hashtag-overview-subtitle" (click)="collapseEmptySection = !collapseEmptySection">Value = 0 or Empty </p>
    <ul class="hashtag-ul" *ngIf="!collapseEmptySection">
        <li class="hashtag-li" *ngFor="let tag of emptyHashTags | distincthashtags">
            <span (click)="onHashtagClicked(tag.page)">{{tag.key}}</span>
            <span class="hashtag-page-info">{{tag.page}}</span>
            <span></span>
        </li>
    </ul>
    <p class="hashtag-overview-subtitle" (click)="collapseSectionWithValues1 = !collapseSectionWithValues1">Value = 1</p>
        <ul class="hashtag-ul" *ngIf="!collapseSectionWithValues1">
            <li class="hashtag-li" *ngFor="let tag of hashTagsWithValue1 | distincthashtags">
                <span (click)="onHashtagClicked(tag.page)">{{tag.key}}</span>
                <span class="hashtag-page-info">{{tag.page}}</span>
                <span></span>
            </li>
        </ul>
</section>
